import { KeycloakInstance } from "keycloak-js";
import React from "react";

export const KeycloakContext = React.createContext<KeycloakInstance | undefined>(undefined)
